import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_2 = { class: "fw-bold pt-1 mb-2 forms_field-headline" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.element.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.element.label), 1)
        ]))
        : _createCommentVNode("", true);
}
